import Storage from 'good-storage'
import Config from '@/config/index.js'
import Decimal from 'decimal.js'

// 根据参数名获取url参数（兼容vue）
export function getUrlParamByName(queryName) {
  return currentUrlToParams(window.location.href, queryName)
}

export function currentUrlToParams(link = window.location.href, key = null) {
  var url = decodeURI(link)
  const paramsUrl = url.split('?')
  if (paramsUrl.length < 2) return key ? null : {}
  const paramsArr = paramsUrl[1].split('&')
  const paramsData = {}
  paramsArr.forEach(r => {
    const data = r.split('=')
    paramsData[data[0]] = data[1]
  })
  if (key) return Object.hasOwnProperty.call(paramsData, key) ? paramsData[key] : null
  return paramsData
}

/**
 * 将对象转换为?a=5&b=7形式
 * @param obj
 * @param firstStr
 * @returns {string|string}
 */
export function obj2StrParams(obj, firstStr = '?') {
  let params = firstStr

  for (const p in obj) {
    params += p + '=' + obj[p] + '&'
  }
  return params.substring(0, params.length - 1)
}
/*
获取当前url
http://192.168.49.71:8081/ => http://192.168.49.71:8081/
http://192.168.49.71:8081/mm/ => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/index.html => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/ff/login.html?id=55 => http://192.168.49.71:8081/mm/ff/

页面名字不能能匹配除\w 的地址，也就是说你的页面名字名字必须由a-z、A-Z、0-9，以及下划线组成才可以。
*/
export function getCurrentUrl() {
  const allUrl = window.location.href
  const match = allUrl.match(/(\S+\/)\w+.html/i)
  return match && Array.isArray(match) && match.length > 1 ? match[1] : allUrl
}

/*
 * 数字转金额格式
 * 参数说明：
 * number：要格式化的数字
 * decimals：保留几位小数
 * dec_point：小数点符号
 * thousands_sep：千分位符号
 * */
export function thousandBitSeparator(number, decimals, dec_point, thousands_sep, fiexdFunc) {
  if (!number) {
    let zero = '0'
    if (decimals > 0) {
      zero += '.'
      for (let i = 0; i < decimals; i++) {
        zero += '0'
      }
    }
    return zero
  } else {
    if (fiexdFunc) {
      number = fiexdFunc(number)
    } else {
      number = numSaveToFloor2(number)
    }
    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep
    var dec = typeof dec_point === 'undefined' ? '.' : dec_point
    var s = ''
    var toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec)
      // return '' + Math.round(n * k) / k
      return '' + (n * k) / k
    }

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    var re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2')
    }

    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }
}

export function numSaveToFixed2(number) {
  if (!number) return 0
  if (number === 0) return 0
  let num = Decimal(number).mul(Decimal(100))
  num = num.toNumber()
  // num = Math.floor(num)
  num = Math.round(num) // 四舍五入
  num = Decimal(num).div(Decimal(100))
  num = num.toNumber()
  return num
}

export function numSaveToFloor2(number) {
  if (!number) return 0
  if (number === 0) return 0
  let num = Decimal(number).mul(Decimal(100))
  num = num.toNumber()
  num = Math.floor(num)
  num = Decimal(num).div(Decimal(100))
  num = num.toNumber()
  return num
}

/**
 * 重置对象（会修改原始对象）
 * @param object
 * @param defaultVal
 */
export function resetObject(object, defaultVal = {}) {
  for (const k in object) {
    if (Object.hasOwnProperty.call(defaultVal, k)) {
      object[k] = defaultVal[k]
    } else {
      if (Array.isArray(object[k])) object[k] = []
      if (typeof object[k] === 'string') object[k] = ''
      if (typeof object[k] === 'number') object[k] = null
      if (typeof object[k] === 'boolean') object[k] = false
    }
  }
}

/**
 * 对象赋值（会修改原始对象）
 * @param object
 * @param valObject
 */
export function fillerLeft(object, valObject = {}) {
  for (const k in object) {
    if (Object.hasOwnProperty.call(valObject, k)) {
      object[k] = valObject[k]
    }
  }
}

/**
 * 获取用户信息
 * @param key
 * @returns {null|*|undefined|{}}
 */
export function getUserInfo(key = null) {
  const userInfo = Storage.get(Config.userInfoKey) || {}
  if (key) return Object.hasOwnProperty.call(userInfo, key) ? userInfo[key] : null
  return userInfo || {}
}

/**
 * 设置用户信息
 * @param user
 * @returns {*}
 */
export function setUserInfo(user) {
  Storage.set(Config.userInfoKey, user)
  return user
}

/**
 * 获取Token
 * @returns {*|undefined}
 */
export function getToken() {
  return window.localStorage.getItem(Config.tokenKey)
}

/**
 * 设置Token
 * @param token
 * @returns {*|undefined}
 */
export function setToken(token) {
  return window.localStorage.setItem(Config.tokenKey, token)
}

/**
 * 移除Token
 * @returns {*}
 */
export function removeToken() {
  return window.localStorage.removeItem(Config.tokenKey)
}
